export enum SnapEntity {
  ANNOTATION = "ANNOTATION",
  CASEWORK = "CASEWORK",
  CEILING = "CEILING",
  CMD = "CMD",
  COLUMN = "COLUMN",
  CONTENT_TEMPLATE_INSTANCE = "CONTENT_TEMPLATE_INSTANCE",
  DATA_TABLE = "DATA_TABLE",
  ELECTRICAL = "ELECTRICAL",
  FLOOR_FINISH = "FLOOR_FINISH",
  FOUNDATION = "FOUNDATION",
  FOUNDATION_PIER = "FOUNDATION_PIER",
  MEASUREMENT = "MEASUREMENT",
  SITE_SHAPE = "SITE_SHAPE",
  OPENING = "OPENING",
  PORCH_COLUMN = "PORCH_COLUMN",
  PROP_INSTANCE = "PROP_INSTANCE",
  RAILING = "RAILING",
  RAILING_POST = "RAILING_POST",
  REFERENCE_GEOM = "REFERENCE_GEOM",
  ROOF = "ROOF",
  ROOM = "ROOM",
  SHEET = "SHEET",
  /** @deprecated */
  SECTION_CUT = "SECTION_CUT",
  SECTION_VIEW = "SECTION_VIEW",
  SHAPE_EDIT_MODE = "SHAPE_EDIT_MODE",
  STAIR = "STAIR",
  UNDERLAY = "UNDERLAY",
  VIEWPORT = "VIEWPORT",
  WALL = "WALL",
  WALL_ASSEMBLY = "WALL_ASSEMBLY",
}
